import {createRouter, createWebHistory} from 'vue-router';
import {applyRouteSeo} from '@/common/seo/seo';

import {commonRoutes} from './routes/common';
import {customerRoutes} from './routes/customer';
import {moduleRoutes} from './routes/module';
import {userRoutes} from './routes/user';
import {notificationRoutes} from './routes/notification';
import {maintenanceRoutes} from './routes/maintenance';
import {fileSystemRoutes} from './routes/fileSystem';
import {liveCoachingRoutes} from './routes/liveCoaching';
import {recipeRoutes} from './routes/recipe';
import {diaryRoutes} from './routes/diary';
import {settingsRoutes} from './routes/settings';
import {courseRoutes} from './routes/course';
import {statisticRoutes} from './routes/statistic';
import {changelogRoutes} from './routes/changelog';
import {coachingProfileRoutes} from './routes/coachingProfile';

const vueRouter = createRouter({
  history: createWebHistory(),
  routes: [
    ...commonRoutes,
    ...customerRoutes,
    ...moduleRoutes,
    ...userRoutes,
    ...notificationRoutes,
    ...maintenanceRoutes,
    ...fileSystemRoutes,
    ...liveCoachingRoutes,
    ...recipeRoutes,
    ...diaryRoutes,
    ...settingsRoutes,
    ...courseRoutes,
    ...statisticRoutes,
    ...changelogRoutes,
    ...coachingProfileRoutes,
  ],
});

vueRouter.afterEach((to) => {
  applyRouteSeo(to);
});

export {
  vueRouter as router,
};
